var progressNotes = (function() {
	var section;
	var VIEW_ALL_NOTES_SECTION;
	var VIEW_SINGLE_NOTE_SECTION;
	var ADD_NOTE_SECTION;
	var ADD_MESSAGE_SECTION;
	var ADD_NOTE_BTN;
	var ADD_MESSAGE_BTN;
	//*add note
	var title;
	var message;
	//*add message
	var messageText;
	// Data & Values
	var selectedNoteId;
	var selectedLocationId;
	var selectedConsumerId;
	var newNoteTitle;
	var newNoteText;
	var newMessageText;
	var consumerNotes;
	var singleNoteData;
	var hasUnreadNote;

	// Workers
	function addNewNote() {
		var titleValue = (newNoteTitle || '').trim();
		var messageValue = (newNoteText || '').trim();
		var insertData = {
			token: $.session.Token,
			noteTitle: UTIL.removeUnsavableNoteText(titleValue),
			note: UTIL.removeUnsavableNoteText(messageValue),
			locationId: selectedLocationId,
			consumerId: selectedConsumerId,
			hideNote: "N",
		};

		progressNotesAjax.insertConsumerNote(insertData, function (results) {
			getConsumerNotes(populateViewNotesSection);
		});
	}
	function addNewMessage() {
		var messageValue = (newMessageText || '').trim();
		var insertData = {
			token: $.session.Token,
			note: UTIL.removeUnsavableNoteText(messageValue),   
			noteId: selectedNoteId,
			consumerId: selectedConsumerId,
		};
		progressNotesAjax.updateConsumerNote(insertData, function (results) {
			getSingleNoteData(selectedNoteId, populateViewSingleNoteSection);
		});
	}
	function getConsumerNotes(callback) {
		function cacheNotes(results) {
			consumerNotes = results;
			callback(results);
		}

		progressNotesAjax.selectNotesByConsumerAndLocation(selectedConsumerId, selectedLocationId, cacheNotes);
	}
	function getSingleNoteData(noteId, callback) {
		function cacheSingleNoteData(results) {
			singleNoteData = results;
			callback(results);
		}

		progressNotesAjax.selectConsumerNote(noteId, cacheSingleNoteData);
	}
	function markNoteAsRead(noteid, consumerid,  noteElement) {

		progressNotesAjax.updateConsumerNoteDateRead(noteid);

		var consumersWithUnreadNotes = roster2.getConsumersWithUnreadNotes();
		hasUnreadNote = consumersWithUnreadNotes[consumerid];
		var noteMenuItem = document.getElementById(noteid)
		if (!hasUnreadNote) {
			var menuItem = document.querySelector('.menuList .progressNote');
			menuItem.classList.remove('needsAttention');
		}

		if (noteMenuItem) {
			noteMenuItem.classList.remove('unreadNote');
		}
		// noteElement.classList.remove('unreadNote');

	}
	function shortenNotePreview(noteString) {
		var note = noteString.split(' ');
		var shortenedNote = note
			.filter((note, index) => {
				return index <= 40;
			})
			.join(' ');

		if (note.length >= 39) {
			shortenedNote += `<span class="ellipsis">...</span>`;
		}

		return shortenedNote;
	}
	function createConsumersWithUnreadNotesObj(results) {
		var newObj = {};

		if (!results) return newObj;

		results.forEach(r => {
			if ($.session.HideProgressNotes || (!$.session.HideProgressNotes && (r.hideNote === "" || r.hideNote === "N"))) {
				if (!newObj[r.c_id]) newObj[r.c_id] = r.c_id;
			}
		});

		return newObj;
	}
	function clearAllGlobalVariables() {
		selectedNoteId = undefined;
		selectedLocationId = undefined;
		selectedConsumerId = undefined;
		newNoteTitle = '';
		newNoteText = '';
		newMessageText = '';
		if (title) {
			var titleInput = title.querySelector('input');
			if (titleInput) titleInput.value = '';
		}

		if (message) {
			var messageInput = message.querySelector('textarea');
			if (messageInput) messageInput.value = '';
		}

		if (messageText) {
			var messageInput = messageText.querySelector('textarea');
			if (messageInput) messageInput.value = '';
		}
	}

	function clearAllGlobalVariablesOnBack() {
		newNoteTitle = '';
		newNoteText = '';
		newMessageText = '';
		if (title) {
			var titleInput = title.querySelector('input');
			if (titleInput) titleInput.value = '';
		}

		if (message) {
			var messageInput = message.querySelector('textarea');
			if (messageInput) messageInput.value = '';
		}

		if (messageText) {
			var messageInput = messageText.querySelector('textarea');
			if (messageInput) messageInput.value = '';
		}

		// grabs all subsections of progress notes
		const viewAllNotesSection = document.querySelector('.viewAllNotesSection');
		const addNoteSection = document.querySelector('.addNoteSection');
		const viewSingleNoteSection = document.querySelector('.viewSingleNoteSection');
		const addMessageSection = document.querySelector('.addMessageSection');

		const sections = [viewAllNotesSection, addNoteSection, viewSingleNoteSection, addMessageSection];

		// Iterate over all sections and make them hidden so the next and back button works correctly
		sections.forEach(section => {
			if (section && section.classList.contains('visible')) {
				section.classList.remove('visible');
				section.classList.add('hidden');
			}
		});      
	}

	// populate
	function populateViewSingleNoteSection(data, singleNoteList) {
		if (!singleNoteList) singleNoteList = VIEW_SINGLE_NOTE_SECTION.querySelector('.singleNoteList');
		singleNoteList.innerHTML = '';

		data.forEach(d => {
			var employeeId = d.emp_id;

			var dateTimeArray = d.Date_Entered.split(' ');
			var timeArray = dateTimeArray[1].split(':');



			// var image = `<img class="pic" src="./images/portraits/${employeeId}.png" onerror="this.src='./images/new-icons/default.jpg'" />`;
			var name = `<p class="name">${d.firstname} ${d.lastname}</p>`;
			var dateTime = `
        <div class="dateTime">
          <p>${dateTimeArray[0]}</p>
          <p>${timeArray[0]}:${timeArray[1]} ${dateTimeArray[2]}</p>
        </div>
      `;
			var title = `<p class="title">${d.notetitle}</p>`;
			var notePreview = `<p>${d.note}</p>`;

			// details - img, name, date, time
			var details = document.createElement('div');
			details.classList.add('progressNote__details');
			// details.innerHTML = `${image}${name}${dateTime}`;
			details.innerHTML = `${name}${dateTime}`;

			// message
			var message = document.createElement('div');
			message.classList.add('progressNote__message');
			message.innerHTML = `
        ${title}${notePreview}
      `;

			var note = document.createElement('div');
			note.classList.add('progressNote');

			note.appendChild(details);
			note.appendChild(message);

			singleNoteList.appendChild(note);
		});
	}
	function populateViewNotesSection(data, allNotesList) {
		var checkbox = section.querySelector('.showNewestCheckbox input');
		var newestFirst = checkbox ? checkbox.checked : true;

		data.sort((a, b) => {
			var da = new Date(a.datecreated);
			var db = new Date(b.datecreated);
			return newestFirst ? db - da : da - db;
		});

		allNotesList = allNotesList || section.querySelector('.allNotesList');
		allNotesList.innerHTML = '';

		data.forEach(d => {
			if ($.session.HideProgressNotes ||
				(!$.session.HideProgressNotes && (d.hidenote === "" || d.hidenote === "N"))
			) {
				var hasBeenRead = d.is_read === '1';
				var noteId = d.noteID;
				var dateTimeArr = d.datecreated.split(' ');
				var timeArr = dateTimeArr[1].split(':');

				var details = document.createElement('div');
				details.classList.add('progressNote__details', 'accessReplies');
				details.innerHTML = `
        <p class="name">${d.MainAuthor}</p>
        <div class="dateTime">
          <p>${dateTimeArr[0]}</p>
          <p>${timeArr[0]}:${timeArr[1]} ${dateTimeArr[2]}</p>
        </div>
      `;

				var message = document.createElement('div');
				message.classList.add('progressNote__message', 'accessReplies');
				message.innerHTML = `
        <p class="title">${d.title}</p>
        <p>${shortenNotePreview(d.note)}</p>
      `;

				var note = document.createElement('div');
				note.setAttribute('data-info-task', 'viewSingleNote');
				note.classList.add('progressNote');
				note.id = noteId;
				if (!hasBeenRead) note.classList.add('unreadNote');
				if ($.session.HideProgressNotes) {
					var hideDetail = document.createElement('div');
					hideDetail.classList.add('progressNote__hidenotecheckbox');
					var hideCb = input.buildCheckbox({
						text: 'Hide Note',
						style: 'secondary',
						isChecked: d.hidenote !== "" && d.hidenote !== "N"
					});
					hideCb.addEventListener('change', e => {
						progressNotesAjax.updateHideNote({
							token: $.session.Token,
							hideNote: e.target.checked ? 'Y' : 'N',
							noteId: noteId,
							consumerId: selectedConsumerId
						});
					});
					hideDetail.appendChild(hideCb);
					note.appendChild(hideDetail);
				}

			// appending details and message sections
				note.appendChild(details);
				note.appendChild(message);
				allNotesList.appendChild(note);
				details.addEventListener('click', () => {
					selectedNoteId = noteId;
					markNoteAsRead(noteId, d.consumer);
					getSingleNoteData(noteId, results => {
						populateViewSingleNoteSection(results);
						consumerInfo.showCardSubSection(VIEW_SINGLE_NOTE_SECTION);
						roster2.refreshRosterList();
					});
				});
			}
		});
	}



	// build
	function buildAddMessageSection() {
		var addMessageSection = document.createElement('div');
		addMessageSection.classList.add('addMessageSection');

		messageText = input.build({
			type: 'textarea',
			label: 'Message',
			style: 'secondary',
			classNames: ['newMessageInput', 'autosize'],
		});
		var sendButton = button.build({
			text: 'Send',
			style: 'secondary',
			type: 'contained',
			icon: 'send',
			classNames: 'disabled', 
			callback: function () {
				if (!sendButton.classList.contains('disabled')) {
					addNewMessage();
					var messageInput = messageText.querySelector('textarea');
					messageInput.value = '';
					newMessageText = '';
					consumerInfo.showCardSubSection(VIEW_SINGLE_NOTE_SECTION);
				}
			},
		});
		var cancelButton = button.build({
			text: 'Cancel',
			style: 'secondary',
			type: 'outlined',
			callback: function () {
				var messageInput = messageText.querySelector('textarea');
				messageInput.value = '';
				newMessageText = '';
				consumerInfo.showCardSubSection(VIEW_SINGLE_NOTE_SECTION);
			},
		});

		function validateAndToggleSendButton() {
			var messageValue = (newMessageText || '').trim();
			if (messageValue) {
				sendButton.classList.remove('disabled');
			} else {
				sendButton.classList.add('disabled');
			}
		}
		var btnWrap = document.createElement('div');
		btnWrap.classList.add('btnWrap');
		btnWrap.appendChild(sendButton);
		btnWrap.appendChild(cancelButton);

		addMessageSection.appendChild(messageText);
		addMessageSection.appendChild(btnWrap);

		messageText.addEventListener('input', event => {
			newMessageText = event.target.value;
			validateAndToggleSendButton();
		});

		ADD_MESSAGE_SECTION = addMessageSection;
		return addMessageSection;
	}
	function buildAddNoteSection() {
		var addNoteSection = document.createElement('div');
		addNoteSection.classList.add('addNoteSection');

		title = input.build({
			type: 'text',
			label: 'Title',
			style: 'secondary',
			classNames: 'newMessageInput',
		});
		message = input.build({
			type: 'textarea',
			label: 'Message',
			style: 'secondary',
			classNames: ['newMessageInput', 'autosize'],
		});
		var sendButton = button.build({
			text: 'Send',
			style: 'secondary',
			type: 'contained',
			icon: 'send',
			callback: function () {
					addNewNote();
					var titleInput = title.querySelector('input');
					var messageInput = message.querySelector('textarea');
					titleInput.value = '';
					messageInput.value = '';
					newNoteTitle = '';
					newNoteText = '';
					consumerInfo.showCardSubSection(VIEW_ALL_NOTES_SECTION);
			},
		});
		var cancelButton = button.build({
			text: 'Cancel',
			style: 'secondary',
			type: 'outlined',
			callback: function () {
				var titleInput = title.querySelector('input');
				var messageInput = message.querySelector('textarea');
				titleInput.value = '';
				messageInput.value = '';
				newNoteTitle = '';
				newNoteText = '';
				consumerInfo.showCardSubSection(VIEW_ALL_NOTES_SECTION);
			},
		});
		title.addEventListener('input', event => {
			newNoteTitle = event.target.value;
		});
		message.addEventListener('input', event => {
			newNoteText = event.target.value;
		});

		var btnWrap = document.createElement('div');
		btnWrap.classList.add('btnWrap');
		btnWrap.appendChild(sendButton);
		btnWrap.appendChild(cancelButton);

		addNoteSection.appendChild(title);
		addNoteSection.appendChild(message);
		addNoteSection.appendChild(btnWrap);

		ADD_NOTE_SECTION = addNoteSection;
		return addNoteSection;
	}
	function buildViewSingleNoteSection() {
		var section = document.createElement('div');
		section.classList.add('viewSingleNoteSection');

		var addNoteBtn = button.build({
			text: 'New',
			icon: 'message',
			style: 'secondary',
			type: 'contained',
			classNames: 'addNoteBtn',
			callback: function() {
				consumerInfo.showCardSubSection(ADD_MESSAGE_SECTION);
			},
		});

		var singleNoteList = document.createElement('div');
		singleNoteList.classList.add('singleNoteList');

		section.appendChild(addNoteBtn);
		section.appendChild(singleNoteList);

		VIEW_SINGLE_NOTE_SECTION = section;
		return section;
	}
	function buildViewAllNotesSection(data) {
		section = document.createElement('div');
		section.classList.add('viewAllNotesSection');

		var addNoteBtn = button.build({
			text: 'New',
			icon: 'message',
			style: 'secondary',
			type: 'contained',
			classNames: 'addNoteBtn',
			callback: function() {
				consumerInfo.showCardSubSection(ADD_NOTE_SECTION);
			},
		});

		var checkboxWrapper = document.createElement('div');
		checkboxWrapper.classList.add('showNewestCheckbox');
		checkboxWrapper.style.display = 'flex';
		checkboxWrapper.style.alignItems = 'center';
		checkboxWrapper.style.justifyContent = 'flex-end'; 
		checkboxWrapper.style.gap = '4px';
		checkboxWrapper.style.marginTop = '8px'; 

		var checkboxLabel = document.createElement('label');
		checkboxLabel.textContent = 'Show Newest On Top';
		checkboxLabel.style.fontWeight = 'bold';
		checkboxLabel.style.cursor = 'pointer';
		var checkboxInput = document.createElement('input');
		checkboxInput.type = 'checkbox';
		checkboxInput.style.transform = 'scale(1.2)';
		checkboxInput.checked = true;
		checkboxInput.style.cursor = 'pointer';

		var checkboxId = 'showNewestCheckbox_' + Date.now();
		checkboxInput.id = checkboxId;
		checkboxLabel.htmlFor = checkboxId;

		// Append label first, then checkbox for "Show Newest On Top []" layout
		checkboxWrapper.appendChild(checkboxLabel);
		checkboxWrapper.appendChild(checkboxInput);

		checkboxInput.addEventListener('change', () => {
			// re-render using cached notes
			if (consumerNotes) {
				populateViewNotesSection(consumerNotes);
			} else {
				getConsumerNotes(populateViewNotesSection);
			}
		});
		// --- end NEW ---

		var notesList = document.createElement('div');
		notesList.classList.add('allNotesList');

		section.appendChild(addNoteBtn);
		section.appendChild(checkboxWrapper); // Added after the button
		section.appendChild(notesList);

		VIEW_ALL_NOTES_SECTION = section;

		// cache notes and initial render
		consumerNotes = data;
		populateViewNotesSection(data);

		return section;
	}

	function init(targetSection, locationId, consumerId) {
		section = targetSection;
		selectedLocationId = locationId;  
		selectedConsumerId = consumerId;
	}

	return {
		buildViewAllNotesSection,
		buildViewSingleNoteSection,
		buildAddNoteSection,
		buildAddMessageSection,
		createConsumersWithUnreadNotesObj,
		clearAllGlobalVariables,
		clearAllGlobalVariablesOnBack,
		getConsumerNotes,
		init,
	};
})();
